












import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
@Component({
    name: "RotateImage"
})
export default class extends Vue {
    @Prop() dataSource!: string;
    @Prop() clearable = false;

    step = 1;
    viewer: Viewer = null as any;
    mounted() {
        this.initViewer();
    }

    @Watch('dataSource', { immediate: true })
    onChangeDataSource(val: any) {
        this.$nextTick(() => {
            const viewer = this.viewer.update();
            const srcC = (viewer as any)?.image?.currentSrc;
            if (srcC && val != srcC) {
                this.viewer.destroy();
                this.initViewer();
            }
        })
    }

    initViewer() {
        const image = document.getElementById('img-preview');
        this.viewer = new Viewer(image as any, {
            inline: true,
            navbar: false,
            minHeight: 320,
            toolbar: {
                zoomIn: 4,
                zoomOut: 4,
                oneToOne: 4,
                reset: 0,
                prev: 0,
                play: 0,
                next: 0,
                rotateLeft: 4,
                rotateRight: 4,
                flipHorizontal: 0,
                flipVertical: 0,
            },
            ready(event: CustomEvent) {
                const el1 = document.querySelectorAll('#container-img a');
                const el2 = document.querySelectorAll('#container-img li');
                const el3 = document.querySelectorAll('#container-img button');
                const el4 = document.querySelectorAll('#container-img div.viewer-button.viewer-fullscreen');
                for (const el of el1) {
                    el.setAttribute('tabindex', '-1');
                }
                for (const el of el2) {
                    el.setAttribute('tabindex', '-1');
                }
                for (const el of el3) {
                    el.setAttribute('tabindex', '-1');
                }
                for (const el of el4) {
                    el.setAttribute('tabindex', '-1');
                }
            },
            viewed() {
                this.viewer.zoomTo(0.3);
            },
        });
    }

    onClear() {
        this.$emit('clear')
    }
}
